import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { SmartAccount, SmartAccountService } from "src/app/services/smart-account.service";

export const smartAccountResolver: ResolveFn<Promise<SmartAccount>> = async () => {
  return firstValueFrom(inject(SmartAccountService).getSmartAccount());
};
